import { useDragOver } from "@minoru/react-dnd-treeview";
import React from "react";
import { IconBasket, IconEye, IconPencilEdit } from "../../../icons/Icon";
import SmuButton from "../../../utils/smu-button/SmuButton";
import SmuSkirt from "../../../utils/smu-skirt/SmuSkirt";

const OrderSkirtItem = (props) => {
  const { depth, isOpen, onToggle, node, hasChild, _delete, _edit, _click, active } =
    props;
  const dragOverProps = useDragOver(node.id, isOpen, onToggle);

  return (
    <SmuSkirt
      style={{ marginLeft: depth * 10 }}
      isOpen={isOpen}
      onToggle={onToggle}
      hasChild={hasChild}
      dragOverProps={dragOverProps}
      _click={_click}
      active={active}
      controls={
        <>
          <SmuButton _className="order-control">
            <IconEye color="#33383F" />
          </SmuButton>
          <SmuButton _className="order-control" control={() => _edit(node)}>
            <IconPencilEdit color="#33383F" />
          </SmuButton>
          <SmuButton
            _className="order-control"
            control={() => _delete(node.id)}
          >
            <IconBasket color="#33383F" />
          </SmuButton>
          {!hasChild && <div className="order-control placelholder" />}
        </>
      }
    >
      <div className="text-truncate my-auto mx-4 w-100 fs-6" onClick={_click}>
        {node.title} {node.code}
      </div>
    </SmuSkirt>
  );
};

export default OrderSkirtItem;
